var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89844 0.25L9.82227 0.275391L3.32227 1.79883L2.6875 1.95117V18.4043L3.34766 18.5059L9.84766 19.7246L9.92383 19.75H11.625V0.25H9.89844ZM13.25 1.875V3.5H15.6875V16.5H13.25V18.125H17.3125V1.875H13.25ZM10 1.90039V18.125L4.3125 17.0586V3.2207L10 1.90039ZM8.6543 9.1875C8.35596 9.1875 8.0957 9.55249 8.0957 10C8.0957 10.4475 8.35596 10.8125 8.6543 10.8125C8.95264 10.8125 9.1875 10.4475 9.1875 10C9.1875 9.55249 8.95264 9.1875 8.6543 9.1875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_1011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoor);
export default __webpack_public_path__ + "static/media/door.b9d72514.svg";
export { ForwardRef as ReactComponent };